import React, { useContext, useState } from "react";
import "./DeleteProject.css";
import { TbStack2 } from "react-icons/tb";
import { useLanguage } from "../../../../LanguageProvider";
import AddModalInputField from "../../../../components/AddModalInputField/AddModalInputField";
import { useToaster } from "../../../../ToasterProvider";
import { GeneralContext } from "../../../../GeneralProvider";
import AlertBox from "../../../../components/AlertBox/AlertBox";

export default function DeleteProject() {
  const { selectedProjectTitle, selectedProjectID, handleDeleteProject } =
    useContext(GeneralContext);
  const { toastWarning } = useToaster();
  const { getTranslation } = useLanguage();
  const [title, setTitle] = useState();
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const handleConfirmDelete = () => {
    handleDeleteProject(selectedProjectID);
    setTitle("");
    setIsAlertOpen(false);
  };

  return (
    <div className="delete-project-container">
      <p className="delete-project-title">{getTranslation("delete")}</p>

      <AddModalInputField
        icon={<TbStack2 size={22} style={{ width: "25px" }} />}
        placeholder={getTranslation("workspaceDeletePrompt") + "*"}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        type={"text"}
      />

      <div className="delete-project-actions">
        <button
          disabled={selectedProjectTitle !== title}
          className="delete-project-button delete"
          onClick={() => setIsAlertOpen(true)}
        >
          {getTranslation("delete")}
        </button>
      </div>

      <AlertBox
        isOpen={isAlertOpen}
        title={getTranslation("areYouSure")}
        message={getTranslation("projectDeleteWarning")}
        onConfirm={handleConfirmDelete}
        onCancel={() => setIsAlertOpen(false)}
        confirmText={getTranslation("yes")}
        cancelText={getTranslation("no")}
        type={"warning"}
      />
    </div>
  );
}
